import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'search-icon',
  templateUrl: 'search-icon.component.html',
  styleUrls: ['search-icon.component.scss'],
})
export class SearchIconComponent {
  @Input() color: string;

  get colorHEX(): string {
    switch (this.color) {
      case 'blue':
        return '#00C0FA';
      case 'mediumgrey':
        return '#CCCCCC';
      default:
        return '#00C0FA';
    }
  }
}
